<template>
    <Loading v-bind:show="showLoadingRecalculo">
        <PageTitle title="PAM - Recálculo" />
        <Grid v-if="dadosAba && dadosAba.recalculo && $featureToggle && $featureToggle.INTEGRA_PAM_RECALCULO"
              v-bind:Data="dadosAba.recalculo"
              v-bind:Header="headerRecalculo"
              Name="Recalculo"
              Title="Total"
              OrderBy="dataRecalculo"
              v-bind:HeaderDetalhes="headerDetalheRecalculo"
              v-bind:DetalhesCombo1="dadosAba.periodo"
              v-bind:DetalhesCombo2="null"
              v-bind:DetalhesCombo3="null" />
    </Loading>

</template>

<script>
    import Grid from '@/components/Grid';
    import Loading from '@/components/Loading';
    import PageTitle from '@/components/PageTitle';
    import Pam from '@/services/PamService.js';

    export default {
        components: {
            Grid,
            Loading,
            PageTitle
        },
        created() {
            //Verifica se tem aluno selecionado
            if (!sessionStorage.Aluno) {
                this.$router.push('home');
            }
            else {
                let a = JSON.parse(sessionStorage.Aluno);
                this.pamService = new Pam(this);

                //Coloca o perfil de aluno disponível na variável aluno
                if (a.PerfilAluno) {
                    this.aluno = a.PerfilAluno;
                    //Verifica se os dados da Aba ja esta carregado
                    if (a.PamRecalculo) {
                        this.dadosAba = a.Pam;
                    }
                    else {
                        this.dadosAba = this.recalculo();
                        this.showLoadingRecalculo = true;
                    }
                }
                else
                    this.$router.push('home');
            }

        },
        beforeDestroy() {
            let aluno = JSON.parse(sessionStorage.Aluno);

            //Armazena os dados da aba pra nao precisar carregar novamente
            aluno.PamRecalculo = this.dadosAba;
            sessionStorage.setItem("Aluno", JSON.stringify(aluno));
        },
        data() {
            return {
                aluno: null,
                headerRecalculo: [
                    {
                        Titulo: "Processo",
                        Field: "pamcod",
                        Width: "100px",
                        Tipo: "numero"
                    },
                    {
                        Titulo: "Periodo",
                        Field: "pelcod",
                        Width: "100px",
                        Tipo: "numero"
                    },
                    {
                        Titulo: "Tipo Processo",
                        Field: "tipoPam",
                        Width: "100px",
                        Tipo: "texto"
                    },
                    {
                        Titulo: "CH Termo",
                        Field: "chTermo",
                        Width: "100px",
                        Tipo: "numero"
                    },
                    {
                        Titulo: "CH Cursada",
                        Field: "chCursada",
                        Width: "100px",
                        Tipo: "numero"
                    },
                    {
                        Titulo: "Data Recalculo",
                        Field: "dataRecalculo",
                        Width: "100px",
                        Tipo: "date"
                    },
                    {
                        Titulo: "Data Cancelamento",
                        Field: "dataCancelamento",
                        Width: "100px",
                        Tipo: "date"
                    }
                ],
                headerDetalheRecalculo: [
                    {
                        Titulo: "Bolsa Concedida",
                        Field: "valorBolsaConcedida",
                        Width: "100px",
                        Tipo: "moeda"
                    },
                    {
                        Titulo: "Serviço Gerado",
                        Field: "valorServicoGerado",
                        Width: "100px",
                        Tipo: "moeda"
                    },
                    {
                        Titulo: "Crédito",
                        Field: "valorCreditoGerado",
                        Width: "100px",
                        Tipo: "moeda"
                    },
                    {
                        Titulo: "Usuário",
                        Field: "usuario",
                        Width: "100px",
                        Tipo: "texto"
                    }
                ],
                dadosAba: null,
                showLoadingRecalculo: false
            }
        },
        methods: {

            recalculo() {
                if (this.$featureToggle.INTEGRA_PAM_RECALCULO) {
                    this.showLoadingRecalculo = true;
                    this.pamService.ConsultaRecalculoPam({
                        codigoAluno: this.aluno.codigoAluno,
                        codigoEspecialidade: this.aluno.codigoEspecialidade
                    }).then(
                        data => {
                            if (data.ok) {
                                this.dadosAba = data.dados;
                            }
                            else {
                                this.$modal.alert(data.mensagem);
                            }
                        },
                        error => {
                            this.$modal.error('Ocorreu um erro ao tentar buscar os dados.', (error.body?.Mensagem || error?.response?.statusText || error.message));
                        }).finally(() => {
                            this.showLoadingRecalculo = false;
                        });
                }
                else {
                    this.$modal.alert(this.$msgFeatureToggle);
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .md-tab {
        padding: 0;
        margin: 0 !important;
    }
</style>
